import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { ICustomAuth } from "../../../models/storeModels/ICustomAuth";

function getInitialState() {
    const initialState: ICustomAuth = {
        customAuthToken: getItemWebStorage('customAuthToken'),
        numberOfAuthTry: 0
    }
    return initialState;
}

export const customAuthSlice = createSlice({
    name: 'customAuth',
    initialState: getInitialState(),
    reducers: {
        setCustomAuthToken(state, action: PayloadAction<any>) {
            state.customAuthToken = action.payload
        },
        setNumberOfAuthTry(state, action: PayloadAction<any>) {
            state.numberOfAuthTry = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setCustomAuthToken,
    setNumberOfAuthTry
} = customAuthSlice.actions
export const customAuthReducer = customAuthSlice.reducer;
